'use client'

import { cn } from '@/lib/utils'
import {
  Typo3SectionSpotSanityAccomodation,
  Typo3SectionSpotSanityCulture,
  Typo3SectionSpotSanityEatDrink,
  Typo3SectionSpotSanityEventList,
  Typo3SectionSpotSanityFreetime,
  Typo3SectionSpotSanityNature,
  Typo3SectionSpotSanityService,
  Typo3SectionSpotSanityShopping,
  Typo3SectionSpotSanitySport,
  Typo3SectionSpotSanitySportServices,
  Typo3SectionSpotSanityStory,
  Typo3SectionSpotSanityTour
} from '@/types'
import { Container, Section } from '@/ui/components'
import { memo } from 'react'

interface Props {
  data:
    | Typo3SectionSpotSanityAccomodation
    | Typo3SectionSpotSanityCulture
    | Typo3SectionSpotSanityService
    | Typo3SectionSpotSanityEatDrink
    | Typo3SectionSpotSanityFreetime
    | Typo3SectionSpotSanityNature
    | Typo3SectionSpotSanityShopping
    | Typo3SectionSpotSanitySport
    | Typo3SectionSpotSanitySportServices
    | Typo3SectionSpotSanityEventList
    | Typo3SectionSpotSanityTour
    | Typo3SectionSpotSanityStory
}

const SingleImage = ({ data }: Props) => {
  // const layout = data?.plugin?.layout
  // const c = data.content
  // const item = c?.items?.[0]

  const getVariant = ():
    | 'hotel'
    | 'event'
    | 'tour'
    | 'story'
    | 'sanityPlugin' => {
    if (data.type === 'spotsanity_accommodation') {
      return 'hotel'
    } else if (data.type === 'spotsanity_eventlist') {
      return 'event'
    } else if (data.type === 'spotsanity_tour') {
      return 'tour'
    } else if (data.type === 'spotsanity_story') {
      return 'story'
    } else {
      return 'sanityPlugin'
    }
  }

  const sectionClasses = cn(
    's-spotsanity-single-image',
    'max-w-[2200px] mx-auto',
    getVariant() === 'story' && 'bg-primary-300'
  )

  return (
    <Section className={sectionClasses}>
      <Container anim="fade-in">
        {/* <Cta5050
          variant={getVariant()}
          data={getVariant() === 'story' ? undefined : item}
          dataStory={getVariant() === 'story' ? item : undefined}
          className="col-span-12"
          image={item?.images && item?.images[0]}
          imagePosition={layout === 'single-image-right' ? 'right' : 'left'}
        /> */}
        ciao
      </Container>
    </Section>
  )
}

export default memo(SingleImage)
